export default __webpack_public_path__ + "static/media/39.438fd67b.jpg";